import type { ComponentProps, CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomArrowUpRightLinkBoxProps = ComponentProps<"svg">

function IconCustomArrowUpRightLinkBox(
  props: IconCustomArrowUpRightLinkBoxProps,
) {
  const {
    className,
    style,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    fill: _ignoredFill,
    width: _ignoredWidth,
    height: _ignoredHeight,
    ...svgProps
  } = props

  const sizeStyle: CSSProperties = {
    width: style?.width ?? 14,
    height: style?.height ?? 14,
    flexShrink: 0,
    ...style,
  }

  return (
    <svg
      className={cn("block", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={sizeStyle}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <path d="M15 3h6v6" fill="none" />
      <path d="M10 14 21 3" fill="none" />
      <path
        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
        fill="none"
      />
    </svg>
  )
}

export default IconCustomArrowUpRightLinkBox
